// blog data

export const Blogs = [
    {
        id:1,
        name:"GirlScript Winter of Contributing (GWOC)- Supervisor",
        tags:["DSA","Data-Structure","Open-Source"],
        date:"1 Sept - 1 Dec, 2021",
        imgSrc:"https://gwoc.girlscript.tech/assets/home-design.png",
        link:""
    },
    {
        id:2,
        name:"WeTech Goldman Sachs Global Scholars Program - Mentee",
        tags:["DSA","Mentorship","Placement"],
        date:"1 April - 1 September, 2021",
        imgSrc:"https://career.webindia123.com/career/options/images/wetech.jpg",
        link:"https://drive.google.com/file/d/13P9SHCgKTLvJNQrumbYCKseLtaRTWDM3/view?usp=sharing"
    },
    {
        id:3,
        name:"Cognitive Application Workshop by Tech Analogy",
        tags:["ML","Data Science","Data Analysis Projects"],
        date:"9 August - 23 August,2021",
        imgSrc:"https://techanalogy.org/cognitive.jpeg",
        link:"https://drive.google.com/file/d/1YJLFMSf_nyPctqbOouWw7RqdcuozqnHL/view?usp=sharing"
    },
    {
        id:4,
        name:"Indian National Academy of Engineering (INAE) Fellowship - IIT Delhi ",
        tags:["CST Studio","Origin","Antenna","Design"],
        date:"3 June-  10 August, 2021",
        imgSrc:"https://cache.careers360.mobi/media/article_images/2020/6/24/INAE.jpg",
        link:""
    },
    {
        id:5,
        name:"LGM Summer of Code - Mentor",
        tags:["C","C++","Reactjs","JavaScript","Open-source"],
        date:"10 June-  10 August, 2021",
        imgSrc:"https://res.cloudinary.com/practicaldev/image/fetch/s--kaHuEpu7--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/6h31ac84husztdkveuey.png",
        link:"https://drive.google.com/file/d/1TzJJLKhjf4fZdDtRNyvAhU65-wNTx2Qw/view?usp=sharing"
    },
    {
        id:6,
        name:"GirlScript Summer of Code(GSSoC) - Contributor",
        tags:["C","C++","Python","ML","Open-source"],
        date:"8 March- 31 May, 2021",
        imgSrc:"https://cdn.hashnode.com/res/hashnode/image/upload/v1623661215136/jPWcZyekD.png",
        link:"https://media-exp1.licdn.com/dms/image/C562DAQEoLcB3nuUu1A/profile-treasury-image-shrink_800_800/0/1623743812354?e=1639936800&v=beta&t=GQp8sgdizt3yEw20-24ptd2sqJPoc21aFrABWVmato4"
    },
    {
        id:7,
        name:"Microsoft Forage Virtual Experience Program",
        tags:["Buissness Foundation Skills","Corporate Work","Presentation"],
        date:"1 Jan- 31 March, 2021",
        imgSrc:"https://cdn.theforage.com/vinternships/companyassets/F9NstoYweMhrBLf2u/cAGzaHrsSeBPSicgw/ENG.png",
        link:"https://drive.google.com/file/d/1DfPkoY1a7d0jP1EhcjQQq4UG_F2NK0d4/view?usp=sharing"
    },
    {
        id:8,
        name:"Winter of Code", 
        tags:["C","C++","Open-source","Documentation"],
        date:"15 Dec,2020- 15 Jan, 2021",
        imgSrc:"https://i.ytimg.com/vi/ZtyBCP6_whw/maxresdefault.jpg",
        link:"https://media-exp1.licdn.com/dms/image/C562DAQGiUlGDLOiaag/profile-treasury-image-shrink_800_800/0/1624646281607?e=1639987200&v=beta&t=OxlmuV-zoa93IjabNdgrUfqVVXXut2GyEY-5LwqtZjQ"
    },
    {
        id:9,
        name:"Verzeo in association with Microsoft - ML using Python Intern",
        tags:["Python","ML","Microsoft","Data Analysis"],
        date:"1 June- 1 August, 2020",
        imgSrc:"https://s3-us-west-2.amazonaws.com/issuewireassets/primg/1416/logo.jpg",
        link:"https://media-exp1.licdn.com/dms/image/C562DAQEmSkyzScFWeQ/profile-treasury-image-shrink_800_800/0/1606143920192?e=1639987200&v=beta&t=RGQzn_bOsvfIXZKlVHiqQmLHYBDMpKD8xQPvec1r3Yg"
    },
  
] 